module.exports = __webpack_public_path__ + "a8a10a3e/img/delete-icon.eb7de062.svg";